// 师资通用签名解决方案
const CryptoJS = require('crypto-js');

const stuff = '7c4ddc01e8';

function Sigenature() {
}

Sigenature.prototype.sigenature = function (parm) {
  if (!parm) {
    throw new Error("Sigenature: parm is not define");
  }

  // 添加时间戳参数
  parm.timestamp = new Date().getTime();

  let sigenatureParm = this.lower(parm);

  sigenatureParm = this.parmSortWithQuestring(sigenatureParm);

  sigenatureParm = sigenatureParm.split('').reverse().join('');

  sigenatureParm = this.friedRiceWithEgg(sigenatureParm, stuff, parm.timestamp);

  sigenatureParm = this.encryptedWithMD5(sigenatureParm);

  return sigenatureParm;
};

Sigenature.prototype.lower = function (parm) {
  const _parm = {};
  Object.keys(parm).map(function(item) {
    _parm[item.toLowerCase()] = parm[item];
    return null;
  });
  return _parm;
};

Sigenature.prototype.parmSortWithQuestring = function (parm) {
  const keys = this.parmSort(parm);
  let _text = '';
  for (let i = 0; i < keys.length; i++) {
    _text = `${_text}${keys[i]}=${parm[keys[i]]}&`;
  }
  if (_text.length > 0) {
    _text = _text.substring(0, _text.length - 1);
  }
  return _text;
};

Sigenature.prototype.parmSort = function (parm) {
  const keys = Object.keys(parm).sort(this.sort);
  return keys;
};

Sigenature.prototype.sort = function (a, b) {
  if (isNaN(a) && isNaN(b)) {
    return compareEn(a, b);
  } else if (!isNaN(a) && !isNaN(b)) {
    return a - b;
  } else if (!isNaN(a)) {
    return -1;
  } else if (!isNaN(b)) {
    return 1;
  }

  function compareEn(a, b) {
    const la = a.toLowerCase();
    const lb = b.toLowerCase();
    const list = [la, lb].sort();
    if (list[0] == la) {
      return -1;
    } else {
      return 1;
    }
  }
};

Sigenature.prototype.encryptedWithMD5 = function (text) {
  const digest = CryptoJS.MD5(text);
  return digest.toString();
};

Sigenature.prototype.friedRiceWithEgg = function (text, s, t) {
  const td = t.toString().substring(t.toString().length - 4);
  let st = td.split('').map((item) => {
    return s[item];
  }).join('');

  st = this.encryptedWithMD5(st);

  return st + text;
};

export default {
  Sigenature,
};